const AUTH_STORAGE_PREFIX = 'sb-jxyfrrsypkmdhylsdjlx-auth-token';
const REMEMBER_SESSION_KEY = 'kindred.keep-logged-in';

export const AUTH_STORAGE_KEY = AUTH_STORAGE_PREFIX;

const canUseBrowserStorage = () => typeof window !== 'undefined';

const getPersistentStore = () => window.localStorage;
const getSessionStore = () => window.sessionStorage;

const getScopedKeys = (store: Storage) => {
  const keys: string[] = [];

  for (let index = 0; index < store.length; index += 1) {
    const key = store.key(index);
    if (key?.startsWith(AUTH_STORAGE_PREFIX)) {
      keys.push(key);
    }
  }

  return keys;
};

const clearScopedKeys = (store: Storage) => {
  for (const key of getScopedKeys(store)) {
    store.removeItem(key);
  }
};

const moveScopedKeys = (from: Storage, to: Storage) => {
  for (const key of getScopedKeys(from)) {
    const value = from.getItem(key);
    if (value !== null) {
      to.setItem(key, value);
    }
    from.removeItem(key);
  }
};

export const getRememberSessionPreference = () => {
  if (!canUseBrowserStorage()) {
    return true;
  }

  return getPersistentStore().getItem(REMEMBER_SESSION_KEY) !== 'false';
};

const getActiveStore = () => (getRememberSessionPreference() ? getPersistentStore() : getSessionStore());

export const setRememberSessionPreference = async (remember: boolean) => {
  if (!canUseBrowserStorage()) {
    return;
  }

  const persistentStore = getPersistentStore();
  const sessionStore = getSessionStore();

  persistentStore.setItem(REMEMBER_SESSION_KEY, remember ? 'true' : 'false');

  if (remember) {
    moveScopedKeys(sessionStore, persistentStore);
    clearScopedKeys(sessionStore);
    return;
  }

  moveScopedKeys(persistentStore, sessionStore);
  clearScopedKeys(persistentStore);
};

export const clearStoredAuthSession = async () => {
  if (!canUseBrowserStorage()) {
    return;
  }

  clearScopedKeys(getPersistentStore());
  clearScopedKeys(getSessionStore());
};

export const authStorage = {
  async getItem(key: string) {
    if (!canUseBrowserStorage()) {
      return null;
    }

    return getActiveStore().getItem(key);
  },
  async setItem(key: string, value: string) {
    if (!canUseBrowserStorage()) {
      return;
    }

    getActiveStore().setItem(key, value);

    if (getRememberSessionPreference()) {
      getSessionStore().removeItem(key);
    } else {
      getPersistentStore().removeItem(key);
    }
  },
  async removeItem(key: string) {
    if (!canUseBrowserStorage()) {
      return;
    }

    getPersistentStore().removeItem(key);
    getSessionStore().removeItem(key);
  },
};
